import { DatePipe } from "@angular/common";
import { ChangeDetectionStrategy, Component, computed, inject } from "@angular/core";

import { AnalyticsClickDirective, ClickAreaDirective } from "@directives";
import { GameFeatures, Round } from "@models";
import { TranslatePipe } from "@pipes";
import { CurrencyService } from "@services";

import { AbstractTabComponent } from "../abstract/abstract-tab.component";
import { BetInfoModalComponent } from "../bet-info-modal/bet-info-modal.component";
import { ButtonComponent } from "../button/button.component";
import { ModalService } from "../modal/modal.service";
import { SvgComponent } from "../svg/svg.component";

interface Item extends Round {
  wC: string;
}

@Component({
  selector: "mn-bets-tab",
  templateUrl: "./bets-tab.component.html",
  styleUrls: ["./bets-tab.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [AnalyticsClickDirective, ButtonComponent, SvgComponent, TranslatePipe, DatePipe, ClickAreaDirective],
})
export class BetsTabComponent extends AbstractTabComponent {
  private readonly mS = inject(ModalService);
  private readonly crS = inject(CurrencyService);

  private readonly prefix = this.crS.symbol;

  protected readonly fair = computed<boolean>(() => !!this.acS.gSB$()?.enabled_features?.includes(GameFeatures.P_F));
  protected readonly its = computed<Item[]>(() => {
    return this.acS.rd$().map(round => {
      const numMultiplier = +round.multiplier;
      const winColor = numMultiplier > 1 ? "c-su" : numMultiplier < 1 ? "c-e" : "";

      return {
        ...round,
        wC: winColor,
        bet: `${this.prefix}${this.crS.round({ value: round.bet })}`,
        win: `${this.prefix}${this.crS.round({ value: round.win })}`,
      };
    });
  });

  protected info(event: Event, round_id: string): void {
    event.stopPropagation();

    this.mS.open({ component: BetInfoModalComponent, data: { round_id }, styleClass: "m-m-b", outside: true });
  }
}
